import BaseService from '@/services/base_service';
import Axios from 'axios';

export default class CenterService extends BaseService {
  async list(params) {
    try {
      return await axios.get('/central-atendimento', params);
    } catch (e) {
      throw e;
    }
  }

  async get(id) {
    try {
      return await axios.get('/central-atendimento/' + id);
    } catch (e) {
      throw e;
    }
  }

  async create(model) {
    try {
      return await axios.post('central-atendimento/', model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async update(model, id) {
    try {
      return await axios.put('/central-atendimento/' + id, model);
    } catch (e) {
      throw this.getErrors(e);
    }
  }

  async delete(id) {
    try {
      return await axios.delete('/central-atendimento/' + id);
    } catch (e) {
      throw e;
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/center.js